import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose, onlyUpdateForKeys } from 'recompose';
import { withStyles } from '@material-ui/core';
import makeSelectorInstance from '../../reference/makeSelectorInstance';
import { getBannerSlides, getSelectedElements, getSelectedSlide } from '../../banner/bannerSelectors';
import {
  setElementDuration,
  setElementsTransitionInType,
  setElementTransitionInDuration,
  setElementsTransitionInDuration,
  setSlidesDuration,
  setSlideDuration,
} from '../../banner/bannerActionsCreators';
import { durationInputProps, secondEndornment, parseFloatHelper } from '../constants';
import { addWarning } from '../../messages/messagesDucks';
import {
  verifyElementsTransitionInDuration,
  allElementsHasSameDeepProperty,
  elementsDeepPropertyAverage,
} from '../helpers';
import { styles } from '../propertyEditorStyles';
import { getSelectedSlideIndex, getSelectedElementIds } from '../../temporary-status/temporaryStatusDucks';
import TextFieldDoped from '../../components/TextFieldDoped';

class ElementTransitionInDuration extends React.Component {
  state = {};

  static getDerivedStateFromProps(nextProps) {
    const { slide, slides, selectedSlideIndex, elements, classes } = nextProps;
    return {
      durationAdditionalData: {
        slide,
        slides,
        selectedSlideIndex,
        elements,
      },
      InputProps: {
        ...secondEndornment,
        classes: {
          root: allElementsHasSameDeepProperty(elements, 'transitionIn', 'duration') === false && classes.averageInput,
        },
      },
    };
  }

  onTransitionInDurationChange = ({ value: duration }) =>
    this.props.setElementsTransitionInDuration({ ids: this.props.ids, duration }); //tracked
  onTransitionInDurationVerify = ({ additionalData: { slide, slides, selectedSlideIndex, elements } }) => {
    const {
      setElementDuration,
      setElementsTransitionInType,
      setSlideDuration,
      setSlidesDuration,
      addWarning,
    } = this.props;
    verifyElementsTransitionInDuration({
      slide,
      slides,
      selectedSlideIndex,
      elements,
      setElementDuration,
      setElementsTransitionInType,
      setSlideDuration,
      setSlidesDuration,
      addWarning,
    });
  };

  render() {
    const { selectedElementIds, intl, elements } = this.props;
    const { durationAdditionalData, InputProps } = this.state;
    return (
      <TextFieldDoped
        key={selectedElementIds}
        type="number"
        label={intl.formatMessage({ id: 'properties.transition.duration' })}
        value={elementsDeepPropertyAverage(elements, 'transitionIn', 'duration')[0]}
        fullWidth
        inputProps={durationInputProps}
        // eslint-disable-next-line react/jsx-no-duplicate-props
        InputProps={InputProps}
        helper={parseFloatHelper}
        additionalData={durationAdditionalData}
        onChangeMethod={this.onTransitionInDurationChange}
        onVerifyMethod={this.onTransitionInDurationVerify}
      />
    );
  }
}

const makeStateToProps = () => state => ({
  elements: makeSelectorInstance(getSelectedElements)(state),
  slide: makeSelectorInstance(getSelectedSlide)(state),
  selectedSlideIndex: makeSelectorInstance(getSelectedSlideIndex)(state),
  slides: makeSelectorInstance(getBannerSlides)(state),
  ids: makeSelectorInstance(getSelectedElementIds)(state),
});

const dispatchToProps = {
  setElementDuration,
  addWarning,
  setSlideDuration,
  setSlidesDuration,
  setElementTransitionInDuration,
  setElementsTransitionInDuration,
  setElementsTransitionInType,
};

export default compose(
  connect(
    makeStateToProps,
    dispatchToProps,
  ),
  onlyUpdateForKeys(['elements', 'selectedElementIds']),
  injectIntl,
  withStyles(styles),
)(ElementTransitionInDuration);
